export default "__VITE_ASSET__6fadb024__"